/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Role } from '../../models/role';

export interface ApiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Params {
  userId?: string;
  Authorization?: string;
}

export function apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json(http: HttpClient, rootUrl: string, params?: ApiKeycloakGetAvailableClientRoleMappingsForUserGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Role>>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Role>>;
    })
  );
}

apiKeycloakGetAvailableClientRoleMappingsForUserGet$Json.PATH = '/api/keycloak/GetAvailableClientRoleMappingsForUser';
